import color from "./color"
import space from "./space"
import font from "./font"
import fontSize from "./font-size"
import image from "./image"
import lineHeight from "./line-height"
import backgroundSize from "./background-size"
import borderRadius from "./border-radius"
import display from "./display"
import boolean from "./boolean"

export default {
  "background-size": backgroundSize,
  "border-radius": borderRadius,
  color,
  font,
  "font-size": fontSize,
  image,
  "line-height": lineHeight,
  space,
  display,
  boolean
}
